import { render, staticRenderFns } from "./riskTipDialog.vue?vue&type=template&id=3b12f1d2"
import script from "./riskTipDialog.vue?vue&type=script&lang=js"
export * from "./riskTipDialog.vue?vue&type=script&lang=js"
import style0 from "./riskTipDialog.vue?vue&type=style&index=0&id=3b12f1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports